elabs.DependencyServiceImpl = class {
  'use strict';

  constructor() {
    this.dependenciesFetched = {};
  }

  // Fetch dependency is used such that multiple Shopify sections can depend on the same script/css, and we only fetch it once
  fetchDependency = function (url, successCallback) {
    if (this.dependenciesFetched[url] && this.dependenciesFetched[url].fetched === true) {
      if (successCallback) {
        successCallback();
      }
      return; // we have already fetched this
    }

    let isFetchingDependency = true;

    if (!this.dependenciesFetched[url]) {
      this.dependenciesFetched[url] = {};
      this.dependenciesFetched[url].fetched = false;
      this.dependenciesFetched[url].successCallbacks = [];

      isFetchingDependency = false;
    }

    if (successCallback) {
      this.dependenciesFetched[url].successCallbacks.push(successCallback);
    }

    if (isFetchingDependency) {
      return;
    }

    this.loadJavascriptAndCssFiles(
      [url],
      () => {
        // success

        this.dependenciesFetched[url].fetched = true;
        this.dependenciesFetched[url].successCallbacks.forEach((successCallback) => {
          successCallback();
        });

        this.dependenciesFetched[url].successCallbacks = [];
      },
      (err) => {
        // fail
        console.error('Failed to fetch dependency: ', url, err);
      },
    );
  };

  // Probably use the el.DependencyService rather than this directly
  loadJavascriptAndCssFiles = function (urls, successCallback, failureCallback) {
    const promises = urls.map(
      (url) =>
        new Promise((resolve, reject) => {
          let domElement;
          const urlWithoutQueryString = url.split('?')[0];
          if (urlWithoutQueryString.endsWith('.css')) {
            domElement = document.createElement('link');
            domElement.type = 'text/css';
            domElement.rel = 'stylesheet';
            domElement.href = url;
          } else {
            domElement = document.createElement('script');
            // domElement.defer = true;
            domElement.type = 'module';
            domElement.src = url;
          }
          domElement.onerror = function (err) {
            reject(err);
          };
          domElement.onload = function () {
            resolve();
          };
          document.body.appendChild(domElement);
        }),
    );

    Promise.all(promises)
      .then(() => {
        if (typeof successCallback === 'function') {
          successCallback();
        }
      })
      .catch((err) => {
        if (typeof failureCallback === 'function') {
          failureCallback(err);
        }
      });
  };
};

elabs.DependencyService = new elabs.DependencyServiceImpl();
